module.exports = __webpack_public_path__ + "static/media/Clifford (3).a7765530.jpg";